export enum Origin {
  CARE = 'care',
  PIPE = 'pipe',
  BREAKDOWN = 'breakdown',
  PIPE_DARTY_MAX = 'pipe_darty_max',
  PIPE_SLOT_POST_PURCHASE = 'pipe_slot_post_purchase',
  PIPE_PSE_POST_PURCHASE = 'pipe_pse_post_purchase',
}
